import { gql, useMutation } from "@apollo/client";
import { Spin } from "antd";
import React, { useState } from "react";
import { CANCEL_OFFER } from "../../../graphql/mutations/offers";
import DeclineIcon from "../../../imgs/declineicon.svg";

const DeclineModal = ({
  firstName,
  lastName,
  fullName,
  bountyId,
  offerId,
  handleCancel,
}) => {
  const [loader, setLoader] = useState(false);
  const [cancelOffer] = useMutation(gql(CANCEL_OFFER));

  const handleSubmit = () => {
    if (offerId) {
      setLoader(true);
      cancelOffer({
        variables: {
          offerId: offerId,
          status: "rejected",
          cancelReason: "",
          cancelDescription: "",
        },
      }).then((res) => {
        setLoader(false);
        handleCancel();
      });
    }
  };

  return (
    <Spin spinning={loader} className="loading">
      <div className="bounty-modal-wrapper submit-wrapper">
        <div className="center-content">
          <img src={DeclineIcon} alt="DeclineIcon" className="icon" />
          <h2 className="heading">Decline offer from @{firstName}</h2>
          <p>You can’t undo this.</p>
        </div>
        <div className="row m-0 w-100 mt-4">
          <div className="col-6 pl-0">
            <button className="btn-style cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
          <div className="col-6 pr-0">
            <button className="btn-style" onClick={handleSubmit}>
              Decline intro
            </button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default DeclineModal;
